export default {
  profile: {
    en: "Profile",ch: "輪廓",
    ja: "プロフィール"
  },
  connectWallet: {
    en: 'Connect Wallet',
    ja: 'コネクトウォレット'
  },
  KYCComingSoon: {
    en: "KYC coming soon",
    ja: "近日中にKYC"
  },
  verifyPersonalData: {
    en: 'Verify personal data',
    ja: '個人データの確認'
  },
  personalData: {
    en: 'Personal data',
    ja: '個人データ'
  },

  copied:{
    en: 'Copied',
    ja: 'コピー機'
  },
  disconnectWallet:{
    en: 'Disconnect wallet',
    ja: 'ウォレットの接続を解除する'
  },
  metamaskWalletDisconnectNotificationTitle:{
    en: 'Wallet not disconnected',
    ja: 'ウォレットが切断されていない'
  },
  metamaskWalletDisconnectNotificationSubtitle:{
    en: 'Please use Metamask to disconnect',
    ja: 'メタマスクで接続を解除してください'
  }
}